module.exports = __webpack_public_path__ + "static/media/msgIcon.dd59d5be.svg";